// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  envName: 'development',
  production: false,
  api: {
    url: "https://devapi.salesommo.com/api/v1",
    old_url: "https://devapi.salesommo.com/",
    baseUrl: "https://devapi.salesommo.com",
    mediaUrl: "https://devapi.salesommo.com/media/",
    broadcastingUrl: "https://devapi.salesommo.com/broadcasting/auth",
  },
  extension_url: "https://chrome.google.com/webstore/detail/salesommo/feijgamkebcdmbhiibphgggokajbcade",
  notification_duration: 10000,
  billing_url: "https://account.salesommo.com/billing",
  stripe: {
    credits750Url: "https://buy.stripe.com/YOUR_750_CREDITS_LINK",
    credits1500Url: "https://buy.stripe.com/YOUR_1500_CREDITS_LINK"
  },
  reverbAppKey: 'sdtl3xgpgtymsogrsfgn',
  reverbHost: 'ws1.devapi.salesommo.com',
  reverbPort: 443, // 6001
  reverbScheme: 'https', // or 'https' for secure
};
